import { Row, Col, Button, Form } from 'react-bootstrap';
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './ProspectForm.css';
import { comunas, regiones } from 'data/data';
import useProspectForm from '../../hooks/selfEnrollment/useProspectForm';
import AlertDialog from 'components/Alerts/AlertDialog';

const ProspectForm = ({ dni, serverError, onSubmitForm, onBackpressed, onCleanError }) => {
  const { prospect, communeList, handleChange, handleAddressChange, handlerSubmit } = useProspectForm(dni);
  const [errors, setErrors] = useState({});

  const handleSubmitForm = () => {
    const formErrors = handlerSubmit(prospect);
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      onSubmitForm(prospect);
      setErrors({});
    }
  };

  return (
    <Row>
      <div className='mt-3'>
        <h5 className='text-left'>Completa tus datos para continuar.</h5>
      </div>
      <Row className='row-content mt-4'>
        <Col sm={12} lg={4} md={4} className='col-content'>
          <Form.Group controlId="firstName">
            <Form.Label className='label-input'>Nombres <span className='require-input'>*</span></Form.Label>
            <Form.Control
              className={errors && errors.firstName ? 'border-require' : ''}
              type="text"
              name="firstName"
              onChange={handleChange}
              value={prospect.firstName}
              placeholder="Nombres"
            />
          </Form.Group>
        </Col>
        <Col sm={12} lg={4} md={4} className='col-content'>
          <Form.Group controlId="lastName">
            <Form.Label className='label-input'>Apellido Paterno <span className='require-input'>*</span></Form.Label>
            <Form.Control
              className={errors && errors.lastName ? 'border-require' : ''}
              type="text"
              name="lastName"
              onChange={handleChange}
              value={prospect.lastName}
              placeholder="Apellido Paterno"
            />
          </Form.Group>
        </Col>
        <Col sm={12} lg={4} md={4} className='col-content'>
          <Form.Group controlId="lastName2">
            <Form.Label className='label-input'>Apellido Materno</Form.Label>
            <Form.Control
              
              type="text"
              name="secondLastName"
              onChange={handleChange}
              value={prospect.secondLastName}
              placeholder="Apellido Materno"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className='row-content mt-4 mt-4-mobile'>
        <Col sm={12} lg={4} md={4} className='col-content'>
          <Form.Label className='label-input'>Fecha de Nacimiento <small>Ej: 01-01-1980</small><span className='require-input'>*</span></Form.Label>
          <div className='content-birthday'>
            <Form.Group className='bd-input' controlId="day">
              <Form.Control
                className={errors && errors.day ? 'border-require' : ''}
                type="text"
                name="day"
                onChange={handleChange}
                value={prospect.day}
                maxLength="2"
                placeholder="Día"
              />
            </Form.Group>
            <Form.Group className='bd-input' controlId="month">
              <Form.Control
                className={errors && errors.month ? 'border-require' : ''}
                type="text"
                name="month"
                onChange={handleChange}
                value={prospect.birthMonth}
                maxLength="2"
                placeholder="Mes"
              />
            </Form.Group>
            <Form.Group className='bd-input' controlId="year">
              <Form.Control
                className={errors && errors.year ? 'border-require' : ''}
                type="text"
                name="year"
                onChange={handleChange}
                value={prospect.birthYear}
                maxLength="4"
                placeholder="Año"
              />
            </Form.Group>
          </div>
        </Col>
        <Col sm={12} lg={3} md={3} className='col-content'>
          <Form.Group controlId="gender">
            <Form.Label className='label-input'>Género <span className='require-input'>*</span></Form.Label>
            <Form.Select
              className={errors && errors.gender ? 'border-require' : ''}
              name="gender"
              onChange={handleChange}
              value={prospect.gender}
            >
              <option value="">Seleccione género</option>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={12} lg={5} md={5} className='col-content'>
          <Form.Group controlId="healthForecast">
            <Form.Label className='label-input'>Previsión de Salud</Form.Label>
            <Form.Select
              className={errors && errors.healthForecast ? 'border-require' : ''}
              name="healthForecast"
              onChange={handleChange}
              value={prospect.healthForecast}
            >
              <option value="">Seleccione una previsión de salud</option>
              <option value="Fonasa">Fonasa</option>
              <option value="Isapre Colmena">Isapre Colmena</option>
              <option value="Isapre Cruz Blanca">Isapre Cruz Blanca</option>
              <option value="Isapre Banmédica">Isapre Banmédica</option>
              <option value="Isapre Consalud">Isapre Consalud</option>
              <option value="Isapre Vida tres">Isapre Vida tres</option>
              <option value="Isapre Esencial">Isapre Esencial</option>
              <option value="Isapre Nueva masvida">Isapre Nueva masvida</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row className='row-content mt-4 mt-4-mobile'>
        <Col sm={12} lg={6} md={6} className='col-content'>
          <Form.Group controlId="email">
            <Form.Label className='label-input'>Correo Electrónico <span className='require-input'>*</span></Form.Label>
            <Form.Control
              className={errors && errors.email ? 'border-require' : ''}
              type="email"
              onChange={handleChange}
              value={prospect.email}
              name="email"
              placeholder="Correo Electronico"
            />
          </Form.Group>
        </Col>
        <Col sm={12} lg={6} md={6} className='content-phone col-content'>
          <div className='pre-phone'>
            <Form.Group controlId="pre">
              <Form.Label className='label-input'>Código <span className='require-input'>*</span></Form.Label>
              <Form.Control
                className={errors && errors.pre ? 'border-require' : ''}
                type="text"
                onChange={handleChange}
                value={prospect.pre}
                maxLength="2"
                name="pre"
                placeholder='56'
              />
            </Form.Group>
          </div>
          <div className="phone">
            <Form.Group controlId="phone">
              <Form.Label className='label-input'>Teléfono Celular <span className='require-input'>*</span></Form.Label>
              <Form.Control
                className={errors && errors.phone ? 'border-require' : ''}
                type="text"
                onChange={handleChange}
                maxLength="9"
                value={prospect.phone}
                name="phone"
                placeholder="Teléfono"
              />
            </Form.Group>
          </div>
        </Col>
      </Row>
      <Row className='row-content mt-4 mt-4-mobile'>
        <Col sm={12} lg={4} md={4} className='col-content'>
          <Form.Group controlId="region">
            <Form.Label className='label-input'>Región <span className='require-input'>*</span></Form.Label>
            <Form.Select
              className={errors && errors.region ? 'border-require' : ''}
              name="region"
              onChange={handleAddressChange}
              value={prospect?.address?.[0].region || ''}
            >
              <option value="">Seleccione una región</option>
              {regiones && Object.keys(regiones).length > 0 ? (
                regiones.map((reg) => (
                  <option key={reg.id} value={reg.name}>
                    {reg.name}
                  </option>
                ))
              ) : null}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={12} lg={3} md={3} className='col-content'>
          <Form.Group controlId="commune">
            <Form.Label className='label-input'>Comuna <span className='require-input'>*</span></Form.Label>
            <Form.Select
              className={errors && errors.commune ? 'border-require' : ''}
              name="commune"
              onChange={handleAddressChange}
              value={prospect?.address?.[0].commune || ''}
            >
              <option value="">Seleccione una comuna</option>
              {communeList && Object.keys(communeList).length > 0 ? (
                communeList.map((comuna) => (
                  <option key={comuna.id} value={comuna.name}>
                    {comuna.name}
                  </option>
                ))
              ) : null}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={12} lg={5} md={5} className='col-content'>
          <Form.Group controlId="street">
            <Form.Label className='label-input'>Dirección de domicilio <span className='require-input'>*</span></Form.Label>
            <Form.Control
              className={errors && errors.street ? 'border-require' : ''}
              type="text"
              onChange={handleAddressChange}
              value={prospect?.address?.[0].street || ''}
              name="street"
              placeholder="Dirección"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className='row-content mt-4 mb-4'>
        <Col className='text-left'>
          <Button
            className='primary text-primary'
            style={{ backgroundColor: 'white', borderColor: 'primary' }}
            type="button"
            onClick={() => onBackpressed()}
          >
            Volver
          </Button>
        </Col>
        <Col className='text-end'>
          <Button
            className='primary'
            type="submit"
            onClick={() => handleSubmitForm()}
          >
            Registrarme
          </Button>
        </Col>
      </Row>
      <AlertDialog
          show={serverError}
          title={"Error al enviar el formulario"}
          bodyMessage={serverError}
          buttonName={"Volver"}
          buttonFunction={() => { onCleanError() }}
          onHide={() => { onCleanError() }}
          error={true}
      />
    </Row>
  );
};

export default ProspectForm;